import Lenis from "lenis";

let lenis = null;

export function initLenis() {
  lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);
  return lenis;
}

export function scrollToId(id) {
  if (lenis) {
    lenis.scrollTo(id, { offset: -72, duration: 1.5, easing: (t) => 1 - Math.pow(1 - t, 4) });
  } else {
    document.querySelector(id)?.scrollIntoView();
  }
}

export function scrollToEl(el) {
  if (lenis && el) {
    lenis.scrollTo(el, { offset: -60, duration: 1.2, easing: (t) => 1 - Math.pow(1 - t, 4) });
  } else {
    el?.scrollIntoView();
  }
}

export function destroyLenis() {
  lenis?.destroy();
  lenis = null;
}
